import { render, staticRenderFns } from "./AddEpisodeTranscriptTab.vue?vue&type=template&id=7c60fa5b&"
import script from "./AddEpisodeTranscriptTab.vue?vue&type=script&lang=js&"
export * from "./AddEpisodeTranscriptTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports